import { Controller } from "@hotwired/stimulus"
import { enter, leave, toggle } from "el-transition"

// Connects to data-controller="kredit-info"
export default class extends Controller {
	static targets = ["optionen"]

	toggle() {
		toggle(this.optionenTarget)
	}
}
